import {
  SealPercent,
  Copy,
  HouseSimple,
  MapPin,
  Medal,
  Bell,
  BellRinging,
  ClipboardText,
  SignOut,
  CaretLeft,
  CaretRight,
  CaretDown,
  CaretUp,
  Question,
  X,
  Invoice,
  House,
  MapPinArea,
  Sparkle,
  SquaresFour,
  ThumbsUp,
  Circle,
  Check,
  ShoppingCart,
  Star,
  CurrencyCircleDollar,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ShareFat,
  Notepad,
  Warning,
  ChatDots,
  UserCircle,
  Eye,
  EyeClosed,
  WhatsappLogo,
  WhatsappIcon,
  PlusSquare,
  Clock,
  User,
  CreditCard,
  FileText,
  ShieldCheck,
  Info,
  CheckCircle,
  WarningCircle,
  XCircle,
  MapPinPlus,
  CalendarPlus,
  CalendarX,
  Funnel,
  Phone,
  Key,
  Timer,
  Plus,
  Minus,
  MinusCircle,
  CalendarDots,
  MapPinLine,
  Receipt,
  NotePencil,
  DotsThreeOutline,
  MapPinSimpleArea,
  MagnifyingGlass,
  Wallet,
  ArrowCounterClockwise,
  Package,
  Files,
  HourglassMedium,
  CalendarCheck,
  Basket,
  UserSwitch,
  CameraPlus,
  Trash,
  AddressBook,
  UsersThree,
  TrayArrowUp,
  Cube,
  StackPlus,
  DotOutline,
  Translate,
  Bank,
  GoogleLogo,
  ServiceAllIcon,
  BadgedUserProfileIcon,
  UserProfileIcon,
  AppleIcon,
  GoogleIcon,
  EmailIcon,
  PasswordIcon,
  LuceSparkle,
  Loading,
  SmileySad,
  Dot,
  Lightning,
  TelegramLogo,
  MessengerLogo,
  InstagramLogo,
  ChinaIcon,
  UsaIcon,
  Gear,
  BellSimple,
  Notification,
  Envelope,
  Gift,
  PlusCircle,
  ArrowFatRight,
  PawPrint,
  DownloadSimple,
} from ".";

export const iconMap = {
  sealPercent: SealPercent,
  copy: Copy,
  houseSimple: HouseSimple,
  mapPin: MapPin,
  medal: Medal,
  bell: Bell,
  bellRinging: BellRinging,
  clipboardText: ClipboardText,
  signOut: SignOut,
  caretLeft: CaretLeft,
  caretRight: CaretRight,
  caretDown: CaretDown,
  caretUp: CaretUp,
  question: Question,
  x: X,
  invoice: Invoice,
  house: House,
  mapPinArea: MapPinArea,
  sparkle: Sparkle,
  squaresFour: SquaresFour,
  thumbsUp: ThumbsUp,
  circle: Circle,
  check: Check,
  shoppingCart: ShoppingCart,
  star: Star,
  currencyCircleDollar: CurrencyCircleDollar,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUpRight: ArrowUpRight,
  shareFat: ShareFat,
  notepad: Notepad,
  warning: Warning,
  chatDots: ChatDots,
  userCircle: UserCircle,
  eye: Eye,
  eyeClosed: EyeClosed,
  whatsappLogo: WhatsappLogo,
  whatsappIcon: WhatsappIcon,
  plusSquare: PlusSquare,
  clock: Clock,
  user: User,
  creditCard: CreditCard,
  fileText: FileText,
  shieldCheck: ShieldCheck,
  info: Info,
  checkCircle: CheckCircle,
  warningCircle: WarningCircle,
  xCircle: XCircle,
  mapPinPlus: MapPinPlus,
  calendarPlus: CalendarPlus,
  calendarX: CalendarX,
  funnel: Funnel,
  phone: Phone,
  key: Key,
  timer: Timer,
  plus: Plus,
  minus: Minus,
  minusCircle: MinusCircle,
  calendarDots: CalendarDots,
  mapPinLine: MapPinLine,
  receipt: Receipt,
  notePencil: NotePencil,
  dotsThreeOutline: DotsThreeOutline,
  mapPinSimpleArea: MapPinSimpleArea,
  magnifyingGlass: MagnifyingGlass,
  wallet: Wallet,
  arrowCounterClockwise: ArrowCounterClockwise,
  package: Package,
  files: Files,
  hourglassMedium: HourglassMedium,
  calendarCheck: CalendarCheck,
  basket: Basket,
  userSwitch: UserSwitch,
  cameraPlus: CameraPlus,
  trash: Trash,
  addressBook: AddressBook,
  usersThree: UsersThree,
  trayArrowUp: TrayArrowUp,
  cube: Cube,
  stackPlus: StackPlus,
  dotOutline: DotOutline,
  translate: Translate,
  bank: Bank,
  googleLogo: GoogleLogo,
  smileySad: SmileySad,
  dot: Dot,
  lightning: Lightning,
  telegramLogo: TelegramLogo,
  messengerLogo: MessengerLogo,
  instagramLogo: InstagramLogo,
  serviceAll: ServiceAllIcon,

  badgedUserProfile: BadgedUserProfileIcon,
  userProfile: UserProfileIcon,
  apple: AppleIcon,
  google: GoogleIcon,
  email: EmailIcon,
  password: PasswordIcon,
  luceSparkle: LuceSparkle,
  loading: Loading,
  chinaIcon: ChinaIcon,
  usaIcon: UsaIcon,
  gear: Gear,
  bellSimple: BellSimple,
  notification: Notification,
  envelope: Envelope,
  gift: Gift,
  plusCircle: PlusCircle,
  arrowFatRight: ArrowFatRight,
  pawPrint: PawPrint,
  downloadSimple: DownloadSimple,
};

export type IconNames = keyof typeof iconMap;
